import DateTimePickerPopover from 'trunks/vue/admin/components/date_time_picker_popover.js';
import DateTimeMixin from 'trunks/vue/share/components/fields/date_time.js';
import FieldMixinForResponse from './mixin.js';

const DateTimeForResponse = {
  mixins: [
    FieldMixinForResponse,
    DateTimeMixin
  ],

  components: {
    'datetime-picker': DateTimePickerPopover
  },

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <template v-if="!editing">
          <div class="form-field-value input-control right-addon disabled" :class='input_class'>
            <input class='controlled-input'
                   type="text"
                   readonly
                   :value='formatedValue'
                   placeholder='请输入' />
            <div class="addon">
              <i :class="icon_class"></i>
            </div>
          </div>
        </template>
        <template v-else>
          <datetime-picker :initValue="value"
                           :viewMode="viewType"
                           position='bottom left'
                           :modeChangeable="viewChangable"
                           @valueChanged='valueChange'>
            <div class="input-control right-addon" slot='trigger' :class='input_class'>
              <div class="controlled-input">
                <div v-if='value'>{{ formatedValue }}</div>
                <div class="placeholder" v-else>请输入</div>
              </div>
              <div class="addon destroy-btn" @click.stop='destroyValue' v-if='value'>
                <i class="slp-minus-circle"></i>
              </div>
              <div class="addon" v-else>
                <i :class="icon_class"></i>
              </div>
            </div>
          </datetime-picker>
        </template>
      </template>
    </Field>
  `,

  computed: {
    fieldDifferenceClass: function() {
      return {
        'datetime-field': true
      };
    },

    icon_class: function() {
      switch (this.field.settings?.input_type) {
        case 'date':
          return 'slp-date';
        case 'time':
          return 'slp-time-circle';
        default:
          return 'slp-date-time';
      }
    },

    input_class: function() {
      if (this.viewChangable) {
        return 'grow-input';
      } else {
        return 'normal-input';
      }
    }
  }
};

export default DateTimeForResponse;
